var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { BlockImageContent } from './block-image-content';
import { useEntity } from '../../hooks/use-entity';
import { classNames } from '../../utils/cn';
import { SliceHeader } from './slice-header';
import { ContentEntityContent } from './content-entity-content';
import { Grid } from '../elements/grid';
import { useColorInfo } from '../../hooks/use-color-info';
var cls = classNames('slice-image-blocks');
export var SliceImageBlocksDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    font-size: 1em;\n  "], ["\n    ", "\n    font-size: 1em;\n  "])), function (_a) {
    var isInverted = _a.isInverted;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR(isInverted ? 'light' : 'dark'));
  })
});
var HeaderStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(10))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: inherit;\n    padding: ", ";\n    font-size: 1em;\n    text-align: center;\n  "], ["\n    color: inherit;\n    padding: ", ";\n    font-size: 1em;\n    text-align: center;\n  "])), theme.UNIT(4))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme.UNIT(6)),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n  "], ["\n    padding: ", " 0 ", ";\n  "])), theme.UNIT(10), theme.UNIT(10))
});
var BlocksStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(10))
});
var BlockStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: inherit;\n    padding: ", ";\n    text-align: center;\n  "], ["\n    color: inherit;\n    padding: ", ";\n    text-align: center;\n  "])), theme.UNIT(4))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Header: styled(SliceHeader)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Content: styled(ContentEntityContent)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Blocks: styled(Grid)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BlocksStyles),
  Block: styled(BlockImageContent)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BlockStyles)
};
export var SliceImageBlocks = function SliceImageBlocks(props) {
  var className = props.className,
      children = props.children;
  var entity = useEntity(props.entity);
  var _a = entity.blocks,
      blocks = _a === void 0 ? [] : _a;

  var _b = useColorInfo(),
      isInverted = _b.isInverted,
      color = _b.color,
      backgroundColor = _b.backgroundColor;

  return React.createElement(My.Container, {
    isInverted: isInverted,
    className: cls.name(className)
  }, React.createElement(My.Header, {
    borderColor: color,
    entity: entity
  }), React.createElement(My.Body, null, React.createElement(My.Content, {
    entity: entity
  }), React.createElement(My.Blocks, {
    desktopAutoColumns: 4,
    tabletAutoColumns: 2,
    items: blocks.map(function (block) {
      return React.createElement(My.Block, {
        key: block.id,
        entity: block
      });
    })
  })));
};
SliceImageBlocks.defaultProps = SliceImageBlocksDefaultProps;
SliceImageBlocks.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;